module.exports = __webpack_public_path__ + "img/icon-deal-empty.fa0dac4e.png";